module.exports = __webpack_public_path__ + "static/img/btn2.998dd68e.png";